import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5cdad2a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "one_c" }
const _hoisted_2 = { class: "form__row" }
const _hoisted_3 = { class: "flex justify-end mt-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_5 = { class: "mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_one_c_trip_list_item = _resolveComponent("one-c-trip-list-item")!
  const _component_list = _resolveComponent("list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.restoreOrders && _ctx.restoreOrders(...args)), ["prevent"])),
      class: "one_c__form"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_the_input, {
          type: "date",
          placeholder: "Дата от",
          value: _ctx.state.from_date,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.from_date) = $event)),
          "is-invalid": _ctx.state_form$.from_date.$error,
          "validation-errors": _ctx.state_form$.from_date.$errors,
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadOneC(1)))
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          type: "date",
          class: "mt-3",
          placeholder: "Дата до",
          value: _ctx.state.to_date,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.to_date) = $event)),
          "is-invalid": _ctx.state_form$.to_date.$error,
          "validation-errors": _ctx.state_form$.to_date.$errors,
          onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadOneC(1)))
        }, null, 8, ["value", "is-invalid", "validation-errors"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_the_button, {
          class: "second text small",
          loading: _ctx.state.is_loading,
          onClick: _ctx.reset
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" Сбросить ")
          ]),
          _: 1
        }, 8, ["loading", "onClick"]),
        _createVNode(_component_the_button, {
          class: "primary small",
          loading: _ctx.state.is_loading,
          type: "submit"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Прокинуть ")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ], 32),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.data_state.trips.is_failed && !_ctx.data_state.trips.failure.error_state.is_cancel)
        ? (_openBlock(), _createBlock(_component_failed_fetch, {
            key: 0,
            loading: _ctx.data_state.trips.is_loading,
            text: "При получении истории заказов произошла ошибка",
            "error-message": _ctx.data_state.trips.failure.error_state.message,
            "error-url": _ctx.data_state.trips.failure.error_state.url,
            "error-status": _ctx.data_state.trips.failure.error_state.status,
            onRefresh: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadOneC(_ctx.data_state.trips.pagination.current_page)))
          }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
        : (_openBlock(), _createBlock(_component_list, {
            key: 1,
            loading: _ctx.data_state.trips.is_loading,
            items: _ctx.data_state.trips.list,
            pagination: "",
            "pagination-current-page": _ctx.data_state.trips.pagination.current_page,
            "pagination-total-pages": _ctx.data_state.trips.pagination.total_pages,
            onChangePage: _ctx.loadOneC
          }, {
            item: _withCtx(({ item }) => [
              _createVNode(_component_one_c_trip_list_item, { item: item }, null, 8, ["item"])
            ]),
            _: 1
          }, 8, ["loading", "items", "pagination-current-page", "pagination-total-pages", "onChangePage"]))
    ])
  ]))
}